import React from 'react';
import { Flex, Button, useColorModeValue } from '@chakra-ui/react';

interface FilterTag {
  label: string;
  value: string;
}

interface AleaFilterTagsProps {
  tags: FilterTag[];
  selectedTags: string[];
  onTagSelect: (value: string) => void;
}

const AleaFilterTags: React.FC<AleaFilterTagsProps> = ({
  tags,
  selectedTags,
  onTagSelect,
}) => {
  // Use Chakra's theming system with fallbacks
  const aleaColor = useColorModeValue('alea.500', 'alea.400');
  const inactiveColor = useColorModeValue('gray.400', 'gray.500');
  const bgColor = useColorModeValue('white', 'gray.800');
  const hoverBgColor = useColorModeValue('white', 'gray.700');

  return (
    <Flex gap="10px" flexWrap={'wrap'} width={{base: '100%', md: 'auto'}}>
      {tags.map((tag) => (
        <Button
          key={tag.value}
          py={3}
          px="25px"
          height="50px"
          borderRadius="25px"
          border={selectedTags.includes(tag.value) ? '1px solid' : 'none'}
          borderColor={selectedTags.includes(tag.value) ? aleaColor : ''}
          bg={bgColor}
          color={selectedTags.includes(tag.value) ? aleaColor : inactiveColor}
          fontWeight={selectedTags.includes(tag.value) ? '500' : '400'}
          fontSize="20px"
          _hover={{ bg: hoverBgColor }}
          onClick={() => onTagSelect(tag.value)}
          width={{ base: '100%', md: 'auto' }}
        >
          {tag.label}
        </Button>
      ))}
    </Flex>
  );
};

export default AleaFilterTags; 